<template>
    <div>
        <div v-if="!events" class="lds-dual-ring"></div>
        <div class="availability" v-else>
            <div class="availability__title">
                <h2 class="profile__title m-0">Availability</h2>
                <a
                    v-if="isPermission"
                    href="javascript:void(0)"
                    class="btn btn_golden"
                    @click="showCustomModal('addEvent', 1)"
                >
                    <span>+ Add event</span>
                </a>
                <EventModal
                    :modal-id="getCustomModalId('addEvent', 1)"
                    :created-by-admin="isAdmin"
                    :artist-id="artistId"
                    :events-type="eventsType"
                    :companies="companies"
                    :disabled-dates="disabledDates"
                    :is-update="false"
                    :permission-for-update="true"
                    @update-events="getEventsList"
                />

            </div>
            <div class="availability__filter">
                <select class="custom-select" v-model="year">
                    <option
                        v-for="year in years"
                        :key="year"
                        :value="year">{{ year }}
                    </option>
                </select>
                <div class="availability__sort">
                    <span class="ttl">legend:</span>
                    <a href="javascript:void(0)" class="sort sort_available">Available</a>
                    <a href="javascript:void(0)" class="sort sort_hold">Hold</a>
                    <a href="javascript:void(0)" class="sort sort_booked">Booked</a>
                    <a href="javascript:void(0)" class="sort sort_blackout">Blackout Day</a>
                    <a href="javascript:void(0)" class="sort sort_travel">Travel Day</a>
                </div>
            </div>
            <div class="calendar__row">
                <div class="calendar__month"></div>
                <div class="calendar__week">Sun</div>
                <div class="calendar__week">Mon</div>
                <div class="calendar__week">Tue</div>
                <div class="calendar__week">Wen</div>
                <div class="calendar__week">Thu</div>
                <div class="calendar__week">Fri</div>
                <div class="calendar__week">Sat</div>
                <div class="calendar__week">Sun</div>
                <div class="calendar__week">Mon</div>
                <div class="calendar__week">Tue</div>
                <div class="calendar__week">Wen</div>
                <div class="calendar__week">Thu</div>
                <div class="calendar__week">Fri</div>
                <div class="calendar__week">Sat</div>
                <div class="calendar__week">Sun</div>
                <div class="calendar__week">Mon</div>
                <div class="calendar__week">Tue</div>
                <div class="calendar__week">Wen</div>
                <div class="calendar__week">Thu</div>
                <div class="calendar__week">Fri</div>
                <div class="calendar__week">Sat</div>
                <div class="calendar__week">Sun</div>
                <div class="calendar__week">Mon</div>
                <div class="calendar__week">Tue</div>
                <div class="calendar__week">Wen</div>
                <div class="calendar__week">Thu</div>
                <div class="calendar__week">Fri</div>
                <div class="calendar__week">Sat</div>
                <div class="calendar__week">Sun</div>
                <div class="calendar__week">Mon</div>
                <div class="calendar__week">Tue</div>
                <div class="calendar__week">Wen</div>
                <div class="calendar__week">Thu</div>
                <div class="calendar__week">Fri</div>
                <div class="calendar__week">Sat</div>
            </div>

            <div class="calendar">
                <div
                    class="calendar__row"
                    v-for="(month, monthIndex) in fullCalendar"
                    :key="monthIndex"
                >
                    <div class="calendar__month">{{ monthIndex + 1 }}</div>
                    <div
                        v-for="(day, index) in month"
                        :key="index"
                        :class="['calendar__day', day?.dayClass ?? '']"
                    >
                        <a
                            v-if="day?.showDetails"
                            @click="openEventModal(day)"
                            href="javascript:void(0)"
                        >
                            {{ day?.day }}
                        </a>
                        <a v-else href="javascript:void(0)">
                            {{ day?.day }}
                        </a>
                        <div class="calendar__info" v-if="day?.showDetails">
                            <p style="color:white">Start Location: <span class="color_primary">{{ day.event.start_location }}</span></p>
                            <p style="color:white">End Location: <span class="color_primary">{{ day.event.end_location }}</span></p>
                            <p style="color:white" v-if="day.event.company_id">Event Venue Name: <span class="color_primary">{{ getCompanyName(day.event.company_id) }}</span></p>
                        </div>
                    </div>
                </div>
                <EventModal
                    v-if="selectedDay"
                    :modal-id="getCustomModalId('showEvent', `${selectedDay?.day}-${selectedDay?.month + 1}`)"
                    :created-by-admin="isAdmin"
                    :artist-id="artistId"
                    :events-type="eventsType"
                    :companies="companies"
                    :existing-event="selectedDay?.event"
                    :disabled-dates="disabledDates"
                    :is-update="true"
                    :permission-for-update="checkPermissions(selectedDay)"
                    @update-events="getEventsList"
                />
            </div>
        </div>
    </div>


</template>

<script>
import ModalHandler from "../../mixins/ModalHandler";
import EventModal from "../Common/EventModal.vue";
import moment from "moment";
import {mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import EventsService from "../../services/EventsService";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import eventsHandler from "../../mixins/eventsHandler";

export default {
    name: 'ArtistAvailability',
    components: {EventModal, DatePicker},
    mixins: [ModalHandler, eventsHandler],
    props: {
        adminType: String
    },
    data() {
        return {
            year: 2025,
            eventsType: [],
            events: [],
            startYear: 2024,
            disabledDates: [],
            selectedDay: null,
        }
    },
    methods: {
        checkPermissions(day) {
            return day.event.created_by.type === this.currentUser.type;
        },
        openEventModal(day) {
            this.selectedDay = day;
            this.$nextTick(() => {
                this.showCustomModal('showEvent', `${day.day}-${day.month + 1}`);
            });
        },
        async fetchEventsType() {
            try {
                const {data: response} = await EventsService.fetchEventsType()
                this.eventsType = response
            } catch {

            }
        },
        getDaysInMonth(month, year) {
            return new Date(year, month + 1, 0).getDate();
        },
        generateCalendar(year) {
            const calendar = [];
            for (let month = 0; month < 12; month++) {
                const daysInMonth = this.getDaysInMonth(month, year);
                const monthData = [];
                const firstDayOfWeek = new Date(year, month, 1).getDay();

                for (let i = 0; i < firstDayOfWeek; i++) {
                    monthData.push(null);
                }
                for (let day = 1; day <= daysInMonth; day++) {
                    const date = new Date(year, month, day);
                    const formattedDate = moment(date).format("YYYY-MM-DD");

                    let dayClass = this.events.hasOwnProperty(formattedDate) && this.events[formattedDate].length > 0
                        ? this.getDayClass(this.events[formattedDate][0].type)
                        : '';
                    let event = this.events.hasOwnProperty(formattedDate) && this.events[formattedDate].length > 0
                        ? this.events[formattedDate][0]
                        : null
                    let showDetails = this.events.hasOwnProperty(formattedDate) && this.events[formattedDate].length > 0
                        ? this.events[formattedDate][0].type !== 'Available'
                        : false;

                    const weekday = date.getDay();
                    monthData.push({
                        month,
                        date,
                        day,
                        weekday,
                        dayClass,
                        event,
                        showDetails
                    });
                }

                calendar.push(monthData);
            }
            return calendar;
        },
        getDisabledDates() {
            this.disabledDates = Object.entries(this.events)
                .filter(([date, eventsArray]) =>
                    eventsArray.length > 0 && eventsArray[0].type !== "Available"
                )
                .map(([date]) => date);
        },
        getDayClass(type) {
            switch (type) {
                case 'Booked':
                    return 'day-booked';
                case 'Available':
                    return 'day-available';
                case 'Hold':
                    return 'day-hold';
                case 'Blackout Day':
                    return 'day-blackout';
                case 'Travel Day':
                    return 'day-travel';
                default:
                    return '';
            }
        },
        async getEventsList() {
            try {
                const {data: response} = await EventsService.fetchEvents(this.artistId, this.year)
                this.events = response
                this.getDisabledDates()
            } catch (e) {
                this.$showErrorMessage()
            }
        }
    },
    watch: {
        artistId: {
            immediate: true,
            handler(newArtistId) {
                if (newArtistId) {
                    this.getEventsList();
                }
            },
        },
    },
    mounted() {
        this.fetchEventsType()
    },
    computed: {
        years() {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let year = this.startYear; year <= currentYear; year++) {
                years.push(year);
            }
            return years;
        },
        isAdmin() {
            return this.currentUser?.type === 'admin';
        },
        isPermission() {
            return this.adminType !== 'agent'
        },
        ...mapState(useArtistStore, {
            artistId: 'artistId',
            companies: 'companies',
            adminPermissions: 'adminPermissions',
            currentUser: 'currentUser'
        }),
        fullCalendar() {
            return this.generateCalendar(this.year);
        },
    },
}

</script>

<style scoped>

</style>
